module.exports = __webpack_public_path__ + "static/img/background.eda444b8.svg";